import { Component, OnInit, Input } from '@angular/core';
import {
    BoothService,
    fbxService,
    GoogleService,
    CommonService,
    ModalService,
    StateService
} from 'src/app/services';

import {
    FBX,
    Modal,
    BoothItem,
    BoothModel
} from 'src/app/models';

// import boothData from '../../data/booths.json';
import modalData from '../../data/modals.json';
import peopleData from '../../data/people.json';

import { TweenMax } from 'gsap';
import * as THREE from 'node_modules/three/build/three.module.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Group, Vector3 } from 'three';
import { Lights } from 'src/app/factories/lights';
import { stringify } from '@angular/compiler/src/util';
import { EnvironmentFBX } from 'src/app/factories/environmentFBX';
import { Booth } from 'src/app/factories/booth';
import { ThrowStmt } from '@angular/compiler';
import { envmaps } from 'src/assets/envmap/index.js';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-room',
    templateUrl: './room.component.html',
    styleUrls: ['./room.component.scss']
})
export class RoomComponent implements OnInit {

    @Input() boothToNavigate: any;

    public reallyLoaded: boolean = false;
    public loaded: boolean = false;
    public container: any;
    public camera: any;
    public scene: any;
    public renderer: any;
    public controls: any;
    public zoomEnabled: any;
    public pmremGenerator: any;
    public clock = new THREE.Clock();
    private boothData: BoothModel;

    public DEBUG: any;
    public lights: Lights;

    public mixer: any;
    public scaleFactor: number = 1;
    public hotspotArray: Array<any> = [];

    public _currentState = -1;
    public _prevState = -1;



    public initialLoad: boolean = false;
    public popStateEventOccured: boolean = false;

    public clickedObject: any = undefined;

    public fbxIcons: Array<FBX> = [];
    public fbxPeople: Array<FBX> = [];
    public fbxData: Array<FBX> = [];
    public booths: Array<Booth> = [];

    public iconMaster: any = undefined;

    public lightsMaster: any = undefined;

    public environment: EnvironmentFBX = undefined;
    public welcomeArea: any = undefined;
    public offsetGroup: any = undefined;
    public colorCircle: Array<any> = []
    public wedges: Array<any> = [];

    public welcomeButton: any = undefined;
    public welcomeTween: any = undefined;

    public modalOpen: boolean = false;
    public headerOpen: boolean = false;
    public noLeftArrow: boolean = false;
    public showExplore: boolean = false;

    public hoverText: any = { visible: false, text: '', top: '0px', left: '0px', el: undefined };
    public hoverTextAlt: any = { visible: false, text: '', top: '0px', left: '0px', el: undefined };

    public mouseXOffset: number = 0;

    constructor(
        private fbxSvc: fbxService,
        private modalSvc: ModalService,
        private commonSvc: CommonService,
        private stateSvc: StateService,
        private boothService: BoothService,
        private router: Router,
        private googleSvc: GoogleService
    ) {

    }

    ngOnInit(): void {
        if (!this.loaded) {
            this.DEBUG = this.zoomEnabled = this.commonSvc.debug.value;
            this.waitForData();
        }
    }
    public waitForData(): void {
        this.boothService.boothDataUpdated.subscribe(data => {
            console.log('boothDataUpdated ', data)
            this.boothData = this.boothService.boothModel;
            if (data) {
                this.subscribe();
                this.threeInit();
                this.animate();
                this.addEvents();
            }
        });
    }
    public subscribe(): void {
        this.router.events.subscribe((val) => {
            if (val instanceof NavigationStart) {
                this.popStateEventOccured = (val.navigationTrigger === 'popstate');
            }

            if (val instanceof NavigationEnd) {
                console.log(
                    'NavigationEnd', val
                )
                const data: BoothItem = this.boothData.booths.find(el => el.url === val.url);

                if (val.urlAfterRedirects === '/medical-info') {
                    this.commonSvc.setMedInfoLink();
                    this.router.navigateByUrl('/');
                    return;
                }

                if (data) {
                    if (this.initialLoad) {
                        this.initialLoad = false;
                        this.boothToNavigate = data.id;
                    } else {
                        this.stateSvc.setState(data.id);
                        this.modalSvc.hideModal();

                        // if (this.popStateEventOccured && val.url === '/medical-info') {
                        //     this.modalSvc.setActiveModalById('leaving-medical');
                        //     this.router.navigateByUrl('/');
                        // } else {
                        //     this.stateSvc.setState(data.id);
                        //     this.modalSvc.hideModal();
                        // }
                    }
                }
            }
        });
        this.stateSvc.currentState.subscribe(data => {
            console.log(': currentState: ', data);
            this._prevState = this._currentState;
            this._currentState = data;
            if (this.loaded) {
                this.refreshState(data);
            }
        });

        this.stateSvc.headerOpen.subscribe(data => {
            this.headerOpen = data;
            this.mouseXOffset = data ? 240 : 0;
            // this.headerOpen = (data && this._currentState > this.stateSvc.states.CENTER);
        });

        this.fbxSvc.modelsLoaded.subscribe(data => {
            console.log(': ROOM LOAD IT: ', data);
            if (data) {
                this.onFBXLoadComplete();
            }
        });

        this.modalSvc.visible.subscribe(data => {
            this.modalOpen = data;
            if (data) {
                document.body.style.cursor = '';
                this.hoverText = { visible: false, text: '', top: '0px', left: '0px', el: undefined };
                this.hoverTextAlt = { visible: false, text: '', top: '0px', left: '0px', el: undefined };
            }
        });
    }

    public addEvents() {
        // const el = window;
        const el = document.getElementById('container');
        el.addEventListener('click', this.onClick.bind(this), false);
        el.addEventListener('mousemove', this.onMouseOver.bind(this), false);
    }

    public onMouseOver(event): void {
        event.preventDefault();

        const mouse = new THREE.Vector2();
        let evX = event.clientX + this.mouseXOffset;
        let evY = event.clientY;
        mouse.x = (evX / window.innerWidth) * 2 - 1;
        mouse.y = - (evY / window.innerHeight) * 2 + 1;
        const raycaster = new THREE.Raycaster();
        raycaster.setFromCamera(mouse, this.camera);
        const intersects = raycaster.intersectObjects(this.scene.children, true);

        if (!this.hoverText.el) {
            this.hoverText.el = document.querySelector('.hover-text.main');
        }

        if (!this.hoverTextAlt.el) {
            this.hoverTextAlt.el = document.querySelector('.hover-text.alt');
        }

        const wedge: BoothItem = this.boothData.booths.find(el => el.id === this._currentState);

        if (intersects.length > 0) {
            switch (intersects[0].object.name) {
                case 'Info_3d_Icon':
                case 'Bigger_Icon':
                    let hovered = intersects[0].object.parent;
                    let split = hovered.name.split('|');
                    evX = event.clientX;

                    this.hoverText.visible = true;
                    this.hoverText.text = split[2].includes('<span') ? split[2] : `<span>${split[2]}</span>`;
                    let elWidth = this.hoverText.el.clientWidth;
                    let elHeight = this.hoverText.el.clientHeight;

                    if (split[2].toLowerCase().includes('resource')) {
                        // we're in the hotspot on the far left - tv box usually

                        // set the hover box to be vertically centered over the hotspot
                        let leftVal = evX - (elWidth / 2);

                        // if the hover box would be outside the window, shift to the right
                        if (leftVal < 0) {
                            leftVal = evX;
                        }

                        this.hoverText.left = leftVal + 'px';
                        this.hoverText.top = (evY - elHeight) - 30 + 'px';
                    } else if (split[2].toLowerCase().includes('safety')) {
                        // we're in the hotspot on the far right

                        // set the hover box to be vertically centered over the hotspot
                        let leftVal = evX - (elWidth / 2);

                        // if the hover box would be outside the window, shift to the left
                        if (leftVal + elWidth > window.innerWidth) {
                            leftVal = evX - elWidth;
                        }

                        this.hoverText.left = leftVal + 'px';
                        this.hoverText.top = (evY - elHeight) - 30 + 'px';
                    } else if (split[2].toLowerCase().includes('website')) {
                        // we're in the hotspot in the center

                        this.hoverText.left = (evX - elWidth) - 40 + 'px';
                        this.hoverText.top = (evY - elHeight / 2) + 'px';
                    } else {
                        this.hoverText.left = evX + 40 + 'px';
                        this.hoverText.top = (evY - elHeight) + 'px';
                    }

                    document.body.style.cursor = 'pointer';
                    break;

                case '_3d_Nav_Arrow':
                    console.log("HELLOOOOOO")

                case 'PrescriptionWarning_Clickable_Bot':
                case 'PrescriptionWarning_Clickable_Top':
                case 'PerscribingInfo_Hotspot':
                    document.body.style.cursor = 'pointer';
                    break;

                default:
                    let clear = true;
                    if (wedge?.interactive) {
                        wedge.interactive.forEach(spot => {
                            if (spot.parent === intersects[0].object.name) {
                                if (spot?.rect) {
                                    if (spot.type === "hover") {
                                        // Logic will need to be adjust to be smarter but for now this works.

                                        if (intersects[0].point.x >= spot.rect.x && intersects[0].point.x < spot.rect.x + spot.rect.width) {
                                            if (intersects[0].point.y < spot.rect.y && intersects[0].point.y > spot.rect.y - spot.rect.height) {
                                                this.hoverTextAlt = {
                                                    visible: true,
                                                    text: spot.alt_text,
                                                    left: '12%',
                                                    top: '72%'
                                                }
                                                clear = false;
                                            }
                                        }
                                    } else if (spot.type === "click") {
                                        if (intersects[0].point.x >= spot.rect.x && intersects[0].point.x < spot.rect.x + spot.rect.width) {
                                            if (intersects[0].point.y < spot.rect.y && intersects[0].point.y > spot.rect.y - spot.rect.height) {
                                                clear = false;
                                            }
                                        }
                                    }
                                } else {
                                    if (spot.type === "hover") {
                                        // Logic will need to be adjust to be smarter but for now this works.
                                        this.hoverTextAlt = {
                                            visible: true,
                                            text: spot.alt_text,
                                            left: '12%',
                                            top: '72%'
                                        }
                                        clear = false;

                                    }
                                }

                            }
                        });
                    }
                    if (clear) {
                        document.body.style.cursor = '';
                        this.hoverText = { visible: false, text: '', top: '0px', left: '0px', el: undefined };
                        this.hoverTextAlt = { visible: false, text: '', top: '0px', left: '0px', el: undefined };
                    } else {
                        document.body.style.cursor = 'pointer';
                    }
                    break;
            } // END SWITCH
        }
    }

    public onClick(event) {
        event.preventDefault();

        const mouse = new THREE.Vector2();
        const evX = event.clientX + this.mouseXOffset;
        const evY = event.clientY;
        mouse.x = (evX / window.innerWidth) * 2 - 1;
        mouse.y = - (evY / window.innerHeight) * 2 + 1;
        const raycaster = new THREE.Raycaster();
        raycaster.setFromCamera(mouse, this.camera);
        var intersects = raycaster.intersectObjects(this.scene.children, true);
        const wedge: BoothItem = this.boothData.booths.find(el => el.id === this._currentState);

        if (intersects.length > 0) {
            console.log('Intersection:', intersects[0].object.name, intersects[0]);
            console.log('Intersection Point: ', intersects[0].point);

            switch (intersects[0].object.name) {
                case 'Info_3d_Icon':
                case 'Bigger_Icon':
                    const clicked = intersects[0].object.parent.name;
                    const split = clicked.split('|');
                    const link = { modal: split[0], isi_expanded: split[1] === 'true', text: split[2] };
                    console.log('Icon Click:', clicked, link);

                    if (link) {
                        this.hotspotClick(link);
                    }
                    break;

                case '_3d_Nav_Arrow':
                    if (intersects[0].object.parent.name === 'BackFromBrand' || intersects[0].object.parent.name === 'WelcomeButton') {
                        this.stateSvc.setState(this.stateSvc.states.CENTER);
                    } else {
                        const parent = parseInt(intersects[0].object.parent.name);
                        console.log("CLICK AN ARROW", parent);
                        this.stateSvc.setState(parent);
                    }

                    this.stateSvc.setHeaderOpen(false);

                    this.googleSvc.sendGAEventById(3, { label: 'arrow', category: 'click' });
                    break;

                case 'PrescriptionWarning_Clickable_Bot':
                case 'PrescriptionWarning_Clickable_Top':
                case 'PerscribingInfo_Hotspot':
                    if (wedge?.interactive) {
                        wedge.interactive.forEach(spot => {
                            if (spot.parent === intersects[0].object.name) {
                                if (spot.type === "click") {
                                    console.log('FOUND THE PARENT', spot.parent);
                                    const hiddenLink = { modal: spot.trigger, isi_expanded: true };
                                    this.hotspotClick(hiddenLink);
                                    console.log('spots', spot.rect);
                                }
                            }
                        });
                    }
                    break;

                default:
                    if (wedge?.interactive) {
                        wedge.interactive.forEach(spot => {
                            if (spot.parent === intersects[0].object.name) {
                                if (spot.type === "click" && spot.rect) {
                                    console.log('FOUND THE PARENT', spot.parent);
                                    console.log('spots', spot.rect);
                                    if (intersects[0].point.x >= spot.rect.x && intersects[0].point.x < spot.rect.x + spot.rect.width) {
                                        if (intersects[0].point.y < spot.rect.y && intersects[0].point.y > spot.rect.y - spot.rect.height) {
                                            const hiddenLink = { modal: spot.trigger, isi_expanded: true };
                                            this.hotspotClick(hiddenLink);
                                        }
                                    }
                                }
                            }
                        });
                    }
                    break;
            }

            document.body.style.cursor = '';

            if (this.DEBUG) {
                this.clickedObject = intersects[0].object.parent;
            }

            // We need to traverse the tree.
            if (intersects[0].parent) {

            }

            // for (let i = 0; i < intersects.length; i++) {
            for (let i = 0; i < 1; i++) {
                // intersects[i].object.material.color.set(0xff0000);
            }
        }
    }

    public threeInit(): void {
        this.container = document.getElementById('container');
        this.camera = new THREE.PerspectiveCamera(33, window.innerWidth / window.innerHeight, 1, 10000);
        this.camera.position.set(0, 200, 3000);
        // DEBUG
        window['camera'] = this.camera;
        this.scene = new THREE.Scene();


        this.offsetGroup = new THREE.Group();
        this.offsetGroup.position.copy(this.stateSvc.CENTER_POINT);
        this.scene.add(this.offsetGroup);

        // Create lights.
        this.lights = new Lights(this.scene, this.stateSvc.CENTER_POINT);

        this.initFBXLoadData();

        this.renderer = new THREE.WebGLRenderer({ antialias: true });
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.shadowMap.enabled = true;

        // this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        this.container.appendChild(this.renderer.domElement);

        this.controls = new OrbitControls(this.camera, this.renderer.domElement);
        // this.controls.target.set(this.camera.position.x, this.camera.position.y, this.camera.position.z);


        let center = this.stateSvc.getLookatCoords(this.stateSvc.states.WELCOME).clone();
        center.add(this.stateSvc.CENTER_POINT);
        this.controls.target.set(center.x, center.y, 0);
        this.camera.position.set(center.x, center.y, center.z);
        // this.controls.target.add(this.stateSvc.CENTER_POINT);


        this.controls.enableDamping = true; // an animation loop is required when either damping or auto-rotation are enabled
        this.controls.dampingFactor = 0.05;
        this.controls.screenSpacePanning = false;
        this.controls.maxPolarAngle = (Math.PI / 2) + 1;
        this.controls.minPolarAngle = -(Math.PI / 2);
        this.controls.rotateSpeed *= -1;
        this.controls.update();

        window['controls'] = this.controls;

        window.addEventListener('resize', this.onWindowResize.bind(this), false);
        if (this.DEBUG) {
            window.addEventListener('keydown', this.onKeyBoard.bind(this), false);

            const geometry = new THREE.CylinderGeometry(0, 10, 30, 4, 1);
            const material = new THREE.MeshPhongMaterial({ color: 0xff0000, flatShading: true });
            const mesh = new THREE.Mesh(geometry, material);
            this.scene.add(mesh);

            // const material2 = new THREE.MeshPhongMaterial({ color: 0x00FF00, flatShading: true });
            // const mesh2 = new THREE.Mesh(geometry, material2);
            // this.offsetGroup.add(mesh2);

            const material3 = new THREE.MeshPhongMaterial({ color: 0x0000FF, flatShading: true });
            const geometry2 = new THREE.CylinderGeometry(0, 20, 45, 4, 1);
            const mesh3 = new THREE.Mesh(geometry2, material3);
            const center = this.stateSvc.getCoordinatesById(this.stateSvc.states.CENTER).clone();
            center.add(this.stateSvc.CENTER_POINT);
            this.scene.add(mesh3);
            mesh3.position.set(center.x, center.y, center.z);

        } else {
            this.scene.fog = new THREE.Fog(0x000000, 2000, 3000);
        }

        this.loaded = true;
        this.pmremGenerator = new THREE.PMREMGenerator(this.renderer);
        this.pmremGenerator.compileEquirectangularShader();
        // this.updateEnvironment();
    }

    updateEnvironment() {
        const environment = envmaps.filter((entry) => entry.id === 'venice-sunset')[0];
        console.log('environment', environment, envmaps);

        this.getCubeMapTexture(environment).then(({ envMap }) => {
            //  this.scene.add(this.vignette);
            this.scene.environment = envMap;
            // this.scene.background = this.state.background ? envMap : null;
        });

    }

    getCubeMapTexture(environment) {
        const { path } = environment;
        // no envmap
        if (!path) return Promise.resolve({ envMap: null });

        return new Promise((resolve, reject) => {
            new RGBELoader()
                .setDataType(THREE.UnsignedByteType)
                .load(path, (texture) => {

                    const envMap = this.pmremGenerator.fromEquirectangular(texture).texture;
                    this.pmremGenerator.dispose();
                    console.log("ENVMAP", envMap);
                    resolve({ envMap });
                }, undefined, reject);
        });

    }


    public initFBXLoadData(): void {
        // Load smaller elements individually.

        this.fbxIcons.push({
            path: 'assets/models/3d_Nav_Arrow.fbx',
            loaded: false,
            fbx: null,
            name: 'Nav_Arrow',
            shadow: true
        });
        this.fbxIcons.push({
            path: 'assets/models/Info_3d_Icon_Bevel.fbx',
            loaded: false,
            fbx: null,
            name: 'Info_Icon',
            shadow: false
        });

        // People are now built in.
        const isLounge = this.boothData.booths.find(b => b.name === 'Bayer_Lounge');
        const isMedInfo = this.boothData.booths.find(b => b.name === 'Medical_Info');
        peopleData.people.forEach(person => {
            if ((person.group === 'Bayer_Lounge' && isLounge) || (person.group === 'Medical_Info' && isMedInfo)) {
                this.fbxPeople.push(person);
            }
        });

        this.fbxIcons.forEach(el => {
            this.fbxSvc.loadFBX(el);
        });
        this.fbxPeople.forEach(el => {
            this.fbxSvc.loadFBX(el);
        });

        // Batch load the scene and wait for it to load.
        this.fbxData.push({
            path: 'assets/models/Environment.fbx',
            loaded: false,
            fbx: null,
            id: 0,
            name: 'Environment',
            shadow: false
        });

        this.fbxData.push({
            path: 'assets/models/Welcome_Area.fbx',
            loaded: false,
            fbx: null,
            id: 2,
            name: 'Welcome',
            shadow: false
        });
        this.boothData.booths.forEach(el => {
            if (el.fbx) {
                this.fbxData.push({
                    path: 'assets/models/' + el.fbx,
                    loaded: false,
                    fbx: null,
                    name: el.name,
                    blurryTexture: el.blurryTexture,
                    mainDisplayName: el.mainDisplayName,
                    id: el.id,
                    shadow: true
                });
            }
        });

        console.log("initFBXLoadData", this.fbxData);
        // Batch load scene. Loading screen waits for this.
        this.fbxSvc.batchLoadFBX(this.fbxData);

    }

    public onFBXLoadComplete(): void {
        console.log("we are loaded.. start it up,", this.fbxData);
        this.createScene();
    }

    public createScene(): void {

        this.fbxIcons.forEach(fbx => {
            if (fbx.fbx) {
                fbx.fbx.traverse(function (child: any) {
                    if (child.isMesh) {
                        if (child.material) {
                            // THIS FIXES BLACK MATERIALS>
                            const meshMat = new THREE.MeshStandardMaterial().clone(child);
                            if (meshMat) {
                                child.material = meshMat;
                            }
                        }
                        fbx.fbx.castShadow = true;
                        fbx.fbx.receiveShadow = true;
                    }
                });
            }
        });

        this.fbxData.forEach(fbx => {
            let cast = false;
            switch (fbx.name) {
                case 'Environment':
                    this.environment = new EnvironmentFBX(fbx, this.offsetGroup, this.stateSvc, this.boothData);
                    this.offsetGroup.add(fbx.fbx);
                    break;
                case 'Welcome':
                    this.welcomeArea = fbx.fbx;
                    this.offsetGroup.add(fbx.fbx);
                    this.createWelcomeButton();
                    break;
                default:

                    let group = new THREE.Group();
                    group.name = fbx.name;
                    console.log('fbx.name', fbx.name);
                    group.add(fbx.fbx);
                    this.offsetGroup.add(group);
                    this.wedges.push(group);
                    const booth = new Booth(fbx, group, this.stateSvc);
                    this.booths.push(booth);
                    if (fbx.blurryTexture) {
                        booth.createBlur();
                    }
                    booth.createIcons(this.fbxIcons.find(el => el.name === 'Info_Icon'), this.stateSvc.CENTER_POINT);
                    if (booth.myBooth.id > this.stateSvc.states.BAYER) {
                        console.log('Group', group)
                        const id = booth.myBooth.id - this.stateSvc.states.BOOTH1;
                        group.rotation.y = (id * -49) * this.stateSvc.DEG_TO_RAD;
                    }

                    cast = true;
                    break;


            }

            fbx.fbx.traverse(function (child: any) {
                if (child.isMesh) {
                    if (child.material) {
                        // THIS FIXES BLACK MATERIALS>
                        // if (child.name === "Sofa_Leather" || child.name === "BayerLogo_Welcome") {
                        if (child.name === "Sofa_Leather") {
                            const meshMat = new THREE.MeshStandardMaterial().clone(child);
                            if (meshMat) {
                                child.material = meshMat;
                            }
                        }
                    }
                    if (child.name === "Nubeqa_Man_LR") {
                        child.position.x = -190;
                        child.position.z = -10;
                    }
                    if (child.name === "Vitrakvi_Woman_01_LR1") {
                        child.visible = false;
                    }
                    if (child.name === "Rep_Guy_ShakeHands_LR") {
                        child.position.x = -150;
                        // fbx.fbx.position.z = 50;
                    }
                    if (child.name.includes("_TV_Display") || child.name.includes("_Display_TV")) {
                        child.receiveShadow = false;
                    }
                }
            });

            fbx.fbx.position.x = this.stateSvc.CENTER_POINT.x;
            fbx.fbx.position.z = this.stateSvc.CENTER_POINT.z;

        });
        // Add people People are now attached to their stuff.
        this.fbxPeople.forEach(fbx => {
            if (fbx.fbx) {
                fbx.fbx.traverse(function (child: any) {
                    if (child.isMesh) {
                        child.castShadow = true;
                        child.receiveShadow = true;
                    }
                    // HACK FOR SILLY CLIENTS
                    if (child.name === "Nubeqa_Man_LR") {
                        fbx.fbx.position.x = -190;
                        fbx.fbx.position.z = -10;
                    }
                    if (child.name === "Rep_Guy_ShakeHands_LR") {
                        fbx.fbx.position.x = -150;
                        // fbx.fbx.position.z = 50;
                    }
                });
                this.offsetGroup.add(fbx.fbx);
                fbx.fbx.position.x = this.stateSvc.CENTER_POINT.x;
                fbx.fbx.position.z = this.stateSvc.CENTER_POINT.z;
            }
        })

        if (this.environment) {
            this.environment.createIcons(this.fbxIcons.find(el => el.name === 'Nav_Arrow'));
            this.changeColorCircle();
        }


        console.log('this.boothToNavigate', this.boothToNavigate);
        this.stateSvc.setState(this.boothToNavigate ? this.boothToNavigate : this.stateSvc.states.WELCOME);

        this.reallyLoaded = true;
    }

    public changeColorCircle() {
        console.log('this.boothData.booths', this.boothData.booths);
        if (!this.boothData.booths) {
            return;
        } // END IF
        let self = this;
        this.environment._fbx.fbx.traverse(function (child: any) {
            let wedge = null;
            let isWedge = false;
            switch (child.name) {
                case 'polySurface3': // xofigo or id 8
                    isWedge = true;
                    wedge = self.boothData.booths.find(el => el.id === 8);
                    console.log('wedge', wedge)
                    break;
                case 'polySurface5': //DK Blue Nebe // nubeqa or 7
                    isWedge = true;
                    wedge = self.boothData.booths.find(el => el.id === 7);
                    break;
                case 'polySurface7': //Vit Mag  or 6
                    isWedge = true;
                    wedge = self.boothData.booths.find(el => el.id === 6);
                    break;
                case 'polySurface9': // STRIVAGA or 5
                    isWedge = true;
                    wedge = self.boothData.booths.find(el => el.id === 5);
                    break;
                case 'polySurface11': // BAYER 4
                    isWedge = true;
                    wedge = self.boothData.booths.find(el => el.id === 4);
                    break;
                case 'polySurface12': // MED INFO or 3 LIGHT BLUE
                    isWedge = true;
                    wedge = self.boothData.booths.find(el => el.id === 3);
                    break;
                case 'polySurface2': // ALIQOPA or 9
                    isWedge = true;
                    wedge = self.boothData.booths.find(el => el.id === 9);
                    break;
            }
            if (isWedge) {
                if (wedge) {
                    child.material = new THREE.MeshPhongMaterial({ color: wedge.wedgeColor });
                } else {
                    child.visible = false;
                }
            }
        });
    }

    public showWelcomeButton(bShow: boolean): void {
        let ani: any;
        if (bShow) {
            ani = { x: 10, y: 10, z: 10, delay: (2), ease: "elastic.out(1, 0.3)", onComplete: this.pulseWelcomeSmall.bind(this), onCompleteParams: [this.welcomeButton] };
        } else {
            if (this.welcomeTween) {
                this.welcomeTween.kill();
            }
            ani = { x: 0, y: 0, z: 0, ease: "elastic.in(1, 0.3)" };
            if (this.welcomeButton.scale.x === 0) {
                return;
            }
        }
        this.welcomeTween = TweenMax.to(this.welcomeButton.scale, 1, ani);
    }

    public pulseWelcomeSmall(obj): void {
        // const big: any = { x: this.scale.x, y: this.scale.y, z: this.scale.z, ease: 'expo.in' };
        const big: any = { x: 8, y: 8, z: 8, yoyo: true, repeat: -1, };
        this.welcomeTween = TweenMax.to(obj.scale, 1, big);
    }

    public pulseWelcomeBig(obj): void {
        return;
        const pulse: any = { x: 10, y: 10, z: 10, onComplete: this.pulseWelcomeSmall.bind(this), onCompleteParams: [obj] };
        this.welcomeTween = TweenMax.to(obj.scale, 1, pulse);
    }


    public createWelcomeButton(): void {
        const iconFBX = this.fbxIcons.find(el => el.name === 'Nav_Arrow');
        this.welcomeButton = iconFBX.fbx.clone();
        // const v3 = this.stateSvc.getCoordinatesById(this.boothData.booths[i].id, 700);
        this.welcomeButton.name = 'WelcomeButton';
        this.welcomeButton.rotation.x = Math.PI / 1.8;
        this.welcomeButton.rotation.z = -Math.PI / 2;
        this.welcomeButton.position.y = 20;
        this.welcomeButton.position.x = 40;
        this.welcomeButton.position.z = 1350;
        // this.welcomeButton.position.z = this.stateSvc.getCoordinatesById(this.stateSvc.states.WELCOME).z - 1500;
        this.welcomeButton.scale.set(0);
        this.welcomeButton.castShadow = true;
        this.welcomeButton.receiveShadow = true;
        console.log('this.welcomeButton', this.welcomeButton)
        this.offsetGroup.add(this.welcomeButton);
    }




    public animate(): void {
        requestAnimationFrame(this.animate.bind(this));
        const delta = this.clock.getDelta();

        if (this.mixer) {
            this.mixer.update(delta);
        }
        this.controls.update();
        this.renderer.render(this.scene, this.camera);
    }

    public onWindowResize() {
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }



    public onKeyBoard(e: KeyboardEvent) {
        console.log('onKeyBoard', e);
        let step = 10;
        // this.controls.target.set(750, 200, 200);

        let center = this.stateSvc.coordinates[this.stateSvc.states.CENTER];

        let radius = 800;
        let angleOffset = 360 / 8;
        let num1 = new Vector3(0, 200, 200);

        let looArg = { x: 0, y: 200, z: 200 };
        let ani = false;

        // let testObj = this.booths[0]._fbx.fbx;
        // let testObj = this.wedges[0];
        let testObj = (this.clickedObject ? this.clickedObject : this.offsetGroup);

        switch (e.code) {
            case 'Digit1':
                this.stateSvc.setState(this.stateSvc.states.BOOTH1);
                ani = true;
                // angleOffset *= 0;
                break;
            case 'Digit2':
                ani = true;
                // angleOffset *= 1;
                // this.stateSvc.setState(this.stateSvc.states.WELCOME);
                this.stateSvc.setState(this.stateSvc.states.BOOTH2);
                break;
            case 'Digit3':
                ani = true;
                // angleOffset *= 2;
                this.stateSvc.setState(this.stateSvc.states.BOOTH3);
                break;
            case 'Digit4':
                ani = true;
                // angleOffset *= 3;
                this.stateSvc.setState(this.stateSvc.states.BOOTH4);
                break;
            case 'Digit5':
                ani = true;
                // angleOffset *= 4;
                this.stateSvc.setState(this.stateSvc.states.BOOTH5);
                // this.stateSvc.setState(this.stateSvc.states.MED_INFO);
                break;
            case 'Digit6':
                ani = true;
                angleOffset *= 5;
                this.stateSvc.setState(this.stateSvc.states.BAYER);
                break;
            case 'Digit7':
                ani = true;
                angleOffset *= 6;
                this.stateSvc.setState(this.stateSvc.states.MED_INFO);
                break;
            case 'Digit8':
                ani = true;
                angleOffset *= 7;
                break;
            case 'ArrowUp':
                // this.stateSvc.nextState();
                // this.offsetGroup.position.z -= 10;
                this.camera.position.z -= step;
                break;
            case 'ArrowDown':
                // this.stateSvc.prevState();
                // this.offsetGroup.position.z += 10;
                this.camera.position.z += step;
                break;
            case 'ArrowRight':

                testObj.rotation.y += this.stateSvc.DEG_TO_RAD * 2;
                // this.lights.changeIntensity(this.lights.lightIntensity + 1);
                // this.camera.fov++;
                // this.onCameraUpdate();
                break;
            case 'ArrowLeft':
                // this.camera.fov--;
                // this.onCameraUpdate();
                testObj.rotation.y -= this.stateSvc.DEG_TO_RAD * 2;
                // this.lights.changeIntensity(this.lights.lightIntensity - 1);

                break;
            case 'KeyZ':
                if (e.ctrlKey) {
                    testObj.position.z -= step;
                } else {
                    testObj.position.z += step;
                }
                break;
            case 'KeyX':
                if (e.ctrlKey) {
                    testObj.position.x -= step;
                } else {
                    testObj.position.x += step;
                }
                break;
            case 'KeyY':
                if (e.ctrlKey) {
                    testObj.position.y -= step;
                } else {
                    testObj.position.y += step;
                }
                break;

            case 'KeyT':
                // stateSvc.CENTER_POINT
                const p = this.stateSvc.CENTER_POINT;
                testObj.position.copy(this.stateSvc.CENTER_POINT);
                // testObj.position.x = -p.x;
                testObj.position.x *= -1;
                testObj.position.y *= -1;
                testObj.position.z *= -1;
                // testObj.position.x += step;
                break;
            case 'KeyC':

                this.booths.forEach(b => {
                    b.handleStateChange(this._currentState);
                });
                break;
            case 'KeyW':
                this.stateSvc.setState(this.stateSvc.states.WELCOME);
                break;
            case 'KeyA':
                this.stateSvc.setState(this.stateSvc.states.CENTER);

                break;

            case 'KeyS':

                break;
        }

        if (ani) {

        }


        if (this.environment) {
            console.log("this.environment.position", this.environment.position);
        }

        console.log("this.camera", this.camera);
        console.log("this.controls", this.controls);
        console.log("testObj", testObj);
        console.log('testObj Coords "x":' + testObj.position.x + ',"y":' + testObj.position.y + ',"z":' + testObj.position.z + '}');

        // this.controls.target.set(this.camera.position.x, this.camera.position.y, this.camera.position.z);
        this.controls.update();

    }

    public onCameraUpdate(): void {
        this.camera.updateProjectionMatrix();
    }


    public onControlsUpdate(): void {
        this.controls.update();
    }

    public onCameraComplete(lookAt): void {
        console.log("camera animation Complete")


        let center = (lookAt) ? lookAt : this.stateSvc.CENTER_POINT;
        this.controls.enabled = true;
        let lookDirection = new Vector3();
        this.camera.getWorldDirection(lookDirection);
        this.controls.target.copy(center);

        // this.controls.target.copy(center).add(lookDirection.multiplyScalar(10));

    }

    aniIcon(obj: any = null): void {
        if (obj === null) {
            obj = this.iconMaster;
        }
        TweenMax.fromTo(obj.rotation, 1, { y: 0 }, { y: 360 * this.stateSvc.DEG_TO_RAD });
        TweenMax.fromTo(obj.position, .5, { y: 200 }, { y: 220 });
        TweenMax.to(obj.position, .5, { y: 200, delay: .5 });
    }

    refreshState(data): void {
        // Change the lights.
        this.animateToLocation(data);
        if (this.environment) {
            this.environment.handleStateChange(this._currentState);
        }

        if (this.booths.length) {
            this.booths.forEach(b => {
                b.handleStateChange(this._currentState);
            });
        }
        switch (this._currentState) {
            case this.stateSvc.states.WELCOME:
                this.controls.maxAzimuthAngle = 30 * this.stateSvc.DEG_TO_RAD;
                this.controls.minAzimuthAngle = -30 * this.stateSvc.DEG_TO_RAD;
                if (this.DEBUG) {
                    this.controls.maxPolarAngle = (Math.PI / 2) + 1;
                    this.controls.minPolarAngle = -(Math.PI / 2);
                } else {
                    this.controls.maxPolarAngle = (Math.PI / 2) + .1;
                    this.controls.minPolarAngle = (Math.PI / 2);
                }
                this.controls.enableRotate = true;
                this.controls.enableZoom = this.zoomEnabled;
                this.showExplore = false;
                this.showWelcomeButton(true);
                if (this.environment) {
                    this.lights.moveLights(this.environment._fbx.fbx);
                }
                // this.lights.moveLights(this.stateSvc.coordinates[this.stateSvc.states.WELCOME]);
                // const booth: Booth = this.wedges.find(el => el.id === this._currentState);

                this.booths.forEach(booth => {
                    booth.showBlurry();
                });
                // this.lights.moveLights(this.stateSvc.coordinates[this.stateSvc.states.CENTER]);
                break;

            case this.stateSvc.states.CENTER:
                this.showWelcomeButton(false);
                const limits = this.stateSvc.getRotationLimits();
                console.log('limits', limits);

                this.controls.maxAzimuthAngle = limits[1] * this.stateSvc.DEG_TO_RAD;
                this.controls.minAzimuthAngle = limits[0] * this.stateSvc.DEG_TO_RAD;
                if (this.DEBUG) {
                    // this.controls.maxAzimuthAngle = Infinity;
                    // this.controls.minAzimuthAngle = Infinity;
                    this.controls.maxPolarAngle = (Math.PI / 2) + 1;
                    this.controls.minPolarAngle = -(Math.PI / 2);
                } else {
                    this.controls.maxPolarAngle = (Math.PI / 2);
                    this.controls.minPolarAngle = (Math.PI / 2);
                } // END IF
                this.controls.enableRotate = true;
                this.controls.enableZoom = this.zoomEnabled;
                this.showExplore = false;
                // Spot light is in the middle.
                // this.lights.moveLights(this.stateSvc.coordinates[this.stateSvc.states.CENTER]);
                if (this.environment) {
                    this.lights.moveLights(this.environment._fbx.fbx);
                }
                this.booths.forEach(booth => {
                    booth.showBlurry();
                });
                break;


            default:
                // const boothItem: BoothItem = this.boothData.booths.find(el => el.id === this._currentState);

                this.booths.forEach(booth => {
                    if (booth._fbx.id === this._currentState) {
                        booth.hideBlurry();
                        this.lights.moveLights(booth._fbx.fbx);
                    } else {
                        booth.showBlurry();
                    }
                });


                this.showWelcomeButton(false);

                this.noLeftArrow = this._currentState === this.stateSvc.states.BAYER;

                if (this.stateSvc.states[this._currentState].includes('BOOTH') || this._currentState === this.stateSvc.states.BAYER) {
                    this.showExplore = !this.stateSvc.ONE_BOOTH_SHOW;
                } else {
                    this.showExplore = false;
                }
                // const rot = this.stateSvc.getBoothRotation();

                // Tony Conti
                this.controls.enableRotate = this.DEBUG;
                this.controls.enableZoom = this.DEBUG;
                this.controls.maxAzimuthAngle = Infinity;
                this.controls.minAzimuthAngle = Infinity;
                if (this.DEBUG) {
                    this.controls.maxPolarAngle = (Math.PI / 2 + 1);
                    this.controls.minPolarAngle = -(Math.PI / 2);
                } else {
                    this.controls.maxPolarAngle = (Math.PI / 2);
                    this.controls.minPolarAngle = (Math.PI / 2);
                }


                // Turn on all booth lights.
                // this.dirLight.target = this.booths[0];
                // this.lights.moveLights(this.stateSvc.getLookatCoords());

                // this.lights.moveLights(this.stateSvc.getStateCoordinates());
                // this.lights.moveLights(this.stateSvc.coordinates[this.stateSvc.states.CENTER]);
                break;
        }
        this.controls.update();
    }


    animateToLocation(id): void {
        // __TODO; make sure we don't animate too fast.. probablt kill the tweens before adding another.

        this.controls.enabled = false;
        let center = this.stateSvc.getStateCoordinates().clone();
        let lookArg = this.stateSvc.getLookatCoords().clone();
        center.add(this.stateSvc.CENTER_POINT);
        lookArg.add(this.stateSvc.CENTER_POINT);
        let bWelcomeSpecial = false; // Need to ani back through center.
        let f = 40;
        let lookAtDelay = 0;
        let aniDelay = 0;
        switch (this._currentState) {
            case this.stateSvc.states.WELCOME:
                f = 33;
                // bWelcomeSpecial = (this._prevState > this.stateSvc.states.CENTER)
                console.log('bWelcomeSpecial', bWelcomeSpecial);
                if (!bWelcomeSpecial && this._prevState > -1) {
                    // lookArg = this.stateSvc.getLookatCoordsById(this.stateSvc.states.CENTER).clone();
                    // lookArg.add(this.stateSvc.CENTER_POINT);
                }
                break;
            case this.stateSvc.states.CENTER:
                f = 45;
                break;
            default:
                break;
        }

        lookAtDelay = (bWelcomeSpecial) ? .65 : .3;
        aniDelay = (bWelcomeSpecial) ? .75 : .5;

        console.log('animateToLocation', this._prevState, this._currentState, lookAtDelay, aniDelay, lookArg, center);


        if (bWelcomeSpecial) {
            const center2 = this.stateSvc.getCoordinatesById(this.stateSvc.states.CENTER).clone();
            center2.add(this.stateSvc.CENTER_POINT);
            TweenMax.to(this.camera.position, .5, {
                x: center2.x,
                y: center2.y,
                z: center2.z,
                onUpdate: this.onCameraUpdate.bind(this),
                onComplete: this.onCameraComplete.bind(this),
                onCompleteParams: [lookArg]
            });
            const look2 = this.stateSvc.getLookatCoordsById(this.stateSvc.states.CENTER).clone();
            look2.add(this.stateSvc.CENTER_POINT);
            // TweenMax.to(this.controls.target, .25, {
            //     x: look2.x,
            //     y: look2.y,
            //     z: look2.z,
            //     delay: .25
            // });
        }

        if (this.camera.fov !== f) {
            TweenMax.to(this.camera, 1, {
                fov: f,
                delay: aniDelay,
                onUpdate: this.onCameraUpdate.bind(this)
            });
        }

        TweenMax.to(this.controls.target, 1, {
            x: lookArg.x,
            y: lookArg.y,
            z: lookArg.z,
            delay: lookAtDelay,
            onUpdate: this.onControlsUpdate.bind(this)

        });

        TweenMax.to(this.camera.position, 1, {
            delay: aniDelay,
            x: center.x,
            y: center.y,
            z: center.z,
            onUpdate: this.onCameraUpdate.bind(this),
            onComplete: this.onCameraComplete.bind(this),
            onCompleteParams: [lookArg]
        });
    }




    public makeLabelObject(hotspot): CSS2DObject {
        const text = document.createElement('div');
        text.className = 'hotspot';
        text.style.backgroundColor = '#000';
        text.style.width = '150px';
        text.style.height = '150px';
        const label = new CSS2DObject(text);
        const forward = this.getPositionFromEquirectangularSpace(hotspot.coords.x * this.scaleFactor, hotspot.coords.y * this.scaleFactor);
        label.position.x = forward.x;
        label.position.y = forward.y;
        label.position.z = forward.z;
        return label;
    }

    public getPositionFromEquirectangularSpace(x, y): THREE.Vector3 {
        const xfrac = x / window.innerWidth;
        const yfrac = y / window.innerHeight;
        const xrot = 2 * Math.PI * xfrac;
        const yrot = (Math.PI) * (yfrac - .5);
        const forward = new THREE.Vector3(50, 0, 0);
        forward.applyAxisAngle(new THREE.Vector3(0, 0, -1), yrot);
        forward.applyAxisAngle(new THREE.Vector3(0, -1, 0), xrot);
        return forward;
    }

    public exploreArrowClick(dir: string) {
        this.googleSvc.sendGAEventById(3, { label: 'explore', category: 'click' });
        this.stateSvc.setHeaderOpen(false);

        if (dir === 'right') {
            this.stateSvc.nextState();
        } else {
            this.stateSvc.prevState();
        }
    }



    public openModal(id: string): void {
        this.modalSvc.setActiveModalById(id);
    }

    public hotspotClick(link: any): void {
        this.googleSvc.sendGAEventById(4, { label: link.text });
        this.stateSvc.setHeaderOpen(false);

        if (link.modal) {
            const data: Modal = modalData.find(el => el.id === link.modal);
            data.isi_expanded = link.isi_expanded === true ? true : false;
            this.modalSvc.setActiveModalByData(data, { text: link.text });
        }
    }
}
